export const ArrowDown = ({color}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill={color}><path d="M480-312 208-584l88-88 184 184 184-184 88 88-272 272Z"/></svg>
    );
};

export const ArrowUp = ({color}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill={color}><path d="M480-496 296-312l-88-88 272-272 272 272-88 88-184-184Z"/></svg>
    );
};